import { isNil } from 'lodash';

export const getEmployerPensionContribution = (
  employeePercentageContribution?: number,
  employerMaxPercentageContribution?: number,
  employerMinPercentageContribution?: number
) => {
  if (isNil(employeePercentageContribution)) {
    return 0;
  }
  if (
    !isNil(employerMaxPercentageContribution) &&
    employeePercentageContribution > employerMaxPercentageContribution
  ) {
    return employerMaxPercentageContribution;
  }
  if (
    !isNil(employerMinPercentageContribution) &&
    employeePercentageContribution < employerMinPercentageContribution
  ) {
    return employerMinPercentageContribution;
  }
  return employeePercentageContribution;
};
